module.exports = __webpack_public_path__ + "static/media/in_a_week_sample_3.36a8ce96.jpg";